/* eslint-disable default-param-last */
import { SHOW_STAFF_DETAILS } from 'actionTypes/staffDetailsActionTypes';

const initialState = {
  status: false,
  selectedStaff: null,
};

const staffDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_STAFF_DETAILS:
      return {
        ...state,
        status: action.payload.status,
        selectedStaff: action.payload.selectedStaff,
      };

    default:
      return state;
  }
};

export default staffDetailsReducer;
